var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NoResourceFoundMessage',{attrs:{"resource-name":_vm.resourceName}})
}
var staticRenderFns = []

export { render, staticRenderFns }